import Navbar from '@components/common/navbar/Navbar';
import { NavLinkData } from '@util/navLinkData';
import NoMatch404 from '@views/common/NoMatch404';
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

interface GenericNavbarLayoutProps {
  allowedRoutes: NavLinkData[];
}

const GenericNavbarLayout = ({ allowedRoutes }: GenericNavbarLayoutProps) => {
  const routeComponents = allowedRoutes.map((x, i) => (
    <Route exact path={x.to} component={x.component} key={i} />
  ));

  return (
    <BrowserRouter>
      <Navbar links={allowedRoutes.filter((x) => x.inNavbar)}></Navbar>
      <main className='h-screen'>
        <Switch>
          {routeComponents}
          <Route path='*'>
            <NoMatch404 />
          </Route>
        </Switch>
      </main>
    </BrowserRouter>
  );
};

export default GenericNavbarLayout;
